import { render } from "./existingDetails.vue?vue&type=template&id=088b582f"
import script from "./existingDetails.vue?vue&type=script&lang=js"
export * from "./existingDetails.vue?vue&type=script&lang=js"

import "./existingDetails.vue?vue&type=style&index=0&id=088b582f&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__